var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacilityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "27px",
    viewBox: "0 0 27 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Work-Order-Details-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Work-order---Details---Editing-group-Flow-1",
    transform: "translate(-1149.000000, -259.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(174.000000, 252.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cta-top-",
    transform: "translate(968.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-View-Profile",
    transform: "translate(7.142857, 7.142857)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 25.7142857 0 25.7142857 25.7142857 0 25.7142857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6278473,7.89202425 L21.63975,7.88012146 L17.8427591,4.08313053 C17.4975781,3.73794953 16.9262441,3.73794953 16.5810631,4.08313053 C16.2358821,4.42831152 16.2358821,4.99964558 16.5810631,5.34482657 L18.4617043,7.22546785 C17.2119111,7.70157957 16.3668128,8.97517841 16.5810631,10.4511247 C16.7715078,11.7604319 17.8903703,12.8197805 19.1996775,12.962614 C19.7591088,13.022128 20.2471233,12.9269056 20.7113322,12.7245582 L20.7113322,21.3064718 C20.7113322,21.9611255 20.1757065,22.4967511 19.5210529,22.4967511 C18.8663993,22.4967511 18.3307736,21.9611255 18.3307736,21.3064718 L18.3307736,15.950215 C18.3307736,14.6409078 17.2595223,13.5696565 15.950215,13.5696565 L14.7599358,13.5696565 L14.7599358,5.23770144 C14.7599358,3.92839422 13.6886844,2.85714286 12.3793772,2.85714286 L5.23770144,2.85714286 C3.92839422,2.85714286 2.85714286,3.92839422 2.85714286,5.23770144 L2.85714286,23.0918908 C2.85714286,23.7465444 3.39276854,24.2821701 4.04742215,24.2821701 L13.5696565,24.2821701 C14.2243101,24.2821701 14.7599358,23.7465444 14.7599358,23.0918908 L14.7599358,15.3550754 L16.5453547,15.3550754 L16.5453547,21.1398327 C16.5453547,22.6990986 17.6642172,24.115531 19.2115803,24.2702673 C20.9969992,24.4488092 22.4967511,23.0561824 22.4967511,21.3064718 L22.4967511,9.9988186 C22.4967511,9.17752589 22.1634729,8.42764993 21.6278473,7.89202425 Z M12.3793772,11.1890979 L5.23770144,11.1890979 L5.23770144,6.42798073 C5.23770144,5.77332712 5.77332712,5.23770144 6.42798073,5.23770144 L11.1890979,5.23770144 C11.8437515,5.23770144 12.3793772,5.77332712 12.3793772,6.42798073 L12.3793772,11.1890979 Z M19.5210529,11.1890979 C18.8663993,11.1890979 18.3307736,10.6534722 18.3307736,9.9988186 C18.3307736,9.34416499 18.8663993,8.80853931 19.5210529,8.80853931 C20.1757065,8.80853931 20.7113322,9.34416499 20.7113322,9.9988186 C20.7113322,10.6534722 20.1757065,11.1890979 19.5210529,11.1890979 Z",
    id: "Shape",
    fill: "#616674"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacilityIcon);
export default __webpack_public_path__ + "static/media/facility-icon.d4ef869b9ebc6a190c01b35d643ad571.svg";
export { ForwardRef as ReactComponent };